import { Product } from '../../types/Products/Products';
import { CheckCircleSolid } from 'iconoir-react';

type ProductCardProps = {
  product: Product;
  selected: string;
};

export const ProductCard = (props: ProductCardProps) => {
  return (
    <div className="my-4 flex flex-col rounded-lg p-4 shadow-lg outline sm:w-full lg:mx-2 lg:w-[28rem]">
      {props.selected === props.product.name && (
        <div className="flex flex-row items-center justify-end text-sky-800">
          <p className="mr-2 text-xl font-bold">Selected</p>
          <CheckCircleSolid />
        </div>
      )}
      <h2 className="justify-self-center text-center text-4xl font-bold">{props.product.name}</h2>
      <p className="text-lg">{props.product.description}</p>
      <p className="text-center text-4xl font-bold">${props.product.oneTimePrice}*</p>
      <p className="text-center text-sm">One-time setup payment</p>
      <div id="selling-points" className="my-2 px-6 text-left">
        <ul className="list-disc">
          {props.product.sellingPoints.map((point) => {
            return <li key={point}>{point}</li>;
          })}
        </ul>
      </div>
      <div
        id="subscription-info"
        className="flex flex-row items-center outline outline-1 outline-offset-2 outline-red-600"
      >
        <div id="subscription-price" className="flex basis-3/12 flex-col items-center">
          <p className="text-xl">${props.product.subscriptionPrice}</p>
        </div>
        <div id="subscription-points" className="basis-9/12 pl-2">
          <p className="text-left text-sm font-bold underline">Annual Membership Maintenance</p>
          <ul className="list-disc text-left text-sm">
            {props.product.subscriptionPoints.map((point) => {
              return <li key={point}>{point}</li>;
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};
